import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
const WarrantyPageLink = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="mt-1">Please visit our{" "}<Link to="/warranty/" className="text-brand cursor-pointer">warranty page</Link>{" "}for more information.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const WarrantyMessage = t0 => {
  const $ = _c(8);
  const {
    yearsSinceOrderDelivered
  } = t0;
  let t1;
  bb0: {
    if (yearsSinceOrderDelivered > 1 && yearsSinceOrderDelivered < 4) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = <>Please note that part of your warranty has expired: Our One-Year Limited Warranty coverage applies to any manufacturer's defects or shipping damage to our fabric, leather, cushioning, seams, tufting, mattresses, wood stains or finishes, moving or mechanical mechanisms found in sleepers, storage items, and recliners and electrical parts and motors (including battery packs).</>;
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    if (yearsSinceOrderDelivered > 3 && yearsSinceOrderDelivered < 11) {
      let t2;
      if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = <>Please note that part of your warranty has expired: Our One-Year Limited Warranty coverage applies to any manufacturer's defects or shipping damage to our fabric, leather, cushioning, seams, tufting, mattresses, wood stains or finishes, moving or mechanical mechanisms found in sleepers, storage items, and recliners and electrical parts and motors (including battery packs).<p>Our Three-Year Limited Warranty coverage applies to the springs and bed slats of your product.</p></>;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      t1 = t2;
      break bb0;
    }
    if (yearsSinceOrderDelivered > 10) {
      let t2;
      if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = <>Please note that your warranty has expired. Our Limited Lifetime Warranty coverage applies from the day you receive your product to 10 years after the initial order delivery date to all of the foundational elements of your furniture: wood frames, joints, bases, legs, and hardware, which are integral to the life of your product.</>;
        $[2] = t2;
      } else {
        t2 = $[2];
      }
      t1 = t2;
      break bb0;
    }
    t1 = "";
  }
  const message = t1;
  if (message) {
    let t2;
    if ($[3] !== message) {
      t2 = <p className="text-justify">{message}</p>;
      $[3] = message;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <WarrantyPageLink />;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== t2) {
      t4 = <div className="rounded mt-2 text-base">{t2}{t3}</div>;
      $[6] = t2;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  return null;
};
WarrantyMessage.propTypes = {
  yearsSinceOrderDelivered: PropTypes.number
};
export default WarrantyMessage;